export const ACTION_TYPES = {
  GET_PROJECT_BY_ID_BASIC_FIELDS_REQUEST:
    'GET_PROJECT_BY_ID_BASIC_FIELDS_REQUEST',
  GET_PROJECT_BY_ID_BASIC_FIELDS_REQUEST_SUCCESS:
    'GET_PROJECT_BY_ID_BASIC_FIELDS_REQUEST_SUCCESS',
  GET_PROJECT_BY_ID_BASIC_FIELDS_REQUEST_FAILURE:
    'GET_PROJECT_BY_ID_BASIC_FIELDS_REQUEST_FAILURE',
  GET_USER_PROJECTS_REQUEST_SUCCESS: 'GET_USER_PROJECTS_REQUEST_SUCCESS',
  ADD_PROJECT_REQUEST_SUCCESS: 'ADD_PROJECT_REQUEST_SUCCESS',
  UPDATE_PROJECT_REQUEST_SUCCESS: 'UPDATE_PROJECT_REQUEST_SUCCESS',
  DELETE_PROJECT_REQUEST_SUCCESS: 'DELETE_PROJECT_REQUEST_SUCCESS',
  DELETE_CUSTOM_FIELD_FROM_PROJECT: 'DELETE_CUSTOM_FIELD_FROM_PROJECT',
};
